
import influencer from "../assets/images/influencer.svg";
import Pioneer from "../assets/images/pioneer.svg";
import logicalthinker from "../assets/images/logical-thinker.svg";
import teamplayer from "../assets/images/team-player.svg";
import persuader from "../assets/images/persuader.svg";
import achiever from "../assets/images/achiever.svg";
import perfectionist from "../assets/images/perfectionist.svg";
import collaborator from "../assets/images/collaborator.svg";
import assessor from "../assets/images/accessor.svg";
import implementor from "../assets/images/implementor.svg";
import motivator from "../assets/images/motivator.svg";
import leader from "../assets/images/leader.svg";
import administrator from "../assets/images/administrator.svg";
import mediator from "../assets/images/mediator.svg";
import versatile from "../assets/images/versatile.svg";



const personalityImageMap = {
    pioneer: Pioneer,
    influencer: influencer,
    teamPlayer: teamplayer,
    logicalThinker: logicalthinker,
    persuader: persuader,
    achiever: achiever,
    perfectionist: perfectionist,
    collaborator: collaborator,
    assessor: assessor,
    implementor: implementor,
    motivator: motivator,
    leader: leader,
    administrator: administrator,
    mediator: mediator,
    allRounder: versatile, // mapped to versatile image
};

export default personalityImageMap;